import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { CircleNotch, CheckCircle, XCircle } from "@phosphor-icons/react";

export default function PaymentCallback() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const ref = params.get("reference") || params.get("trxref");
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    if (!ref) return setStatus("error");
    api.get(`/payments/paystack/verify/${ref}`)
      .then((r) => setStatus(r.data.status === "success" ? "paid" : "failed"))
      .catch(() => setStatus("failed"));
  }, [ref]);

  return (
    <div className="min-h-screen grid place-items-center bg-[#F9F7F4]">
      <div className="card !p-10 max-w-md text-center" data-testid="payment-callback-card">
        {status === "checking" && <><CircleNotch size={40} className="animate-spin mx-auto text-[#0A3622]" /><h2 className="font-display text-2xl mt-4 font-medium">Verifying payment…</h2></>}
        {status === "paid" && <><CheckCircle size={48} weight="fill" className="mx-auto text-[#2D7A5D]" /><h2 className="font-display text-2xl mt-4 font-medium">Payment received</h2><p className="text-sm text-[#4F5D4F] mt-2">Thank you. Your transaction is confirmed.</p></>}
        {status === "failed" && <><XCircle size={48} weight="fill" className="mx-auto text-[#C93B3B]" /><h2 className="font-display text-2xl mt-4 font-medium">Payment failed</h2><p className="text-sm text-[#4F5D4F] mt-2">Please try again or contact support.</p></>}
        <button onClick={() => nav("/parent")} className="btn-primary mt-6" data-testid="payment-callback-back">Back to dashboard</button>
      </div>
    </div>
  );
}
